export const translateStatus = (status, scheduled) => {
  if ( !status )
    return console.error("Error: Status is null. \r\n    in momentumStatus (at src/momentum/functions/momentumStatus.jsx:3)")

  if ( status === "Paused" && scheduled )
    return "Agendado"
  
  status = status.toUpperCase()
  const translateList = {
    PAUSED: "Pausado",
    ACTIVE: "Ativo",
    DELETED: "Removido",
    DONE: "Finalizado",
    DRAFT: "Rascunho" 
  }

  if ( !translateList[status] ) return status
  return translateList[status]
}